// import Swiper from 'swiper';
// import { Autoplay } from 'swiper/modules';

// import delegateEvent from '../utilities/delegateEvent.js';

export default function Feature() {
  return {
    init: () => {
      const features = document.querySelectorAll("[data-w-feature]");
      if (features.length === 0) return;

      const random = Math.floor(Math.random() * (features.length - 1));
      features[random].classList.remove("tw-hidden");
      features[random].setAttribute('data-w-swiper-container', '');
    }
  }
}
